import React from 'react';

const SvgLogoE24 = (props: any) => (
    <svg width={36} height={36} {...props}>
        <g fill="none" fillRule="evenodd">
            <circle fill="#FFF" cx={17.599} cy={17.994} r={17.5} />
            <g fillRule="nonzero">
                <path
                    d="M14.568 10.86h17.269V25.2h-17.27V10.93v-.068zm1.216 1.217v2.237h2.523c.076 0 .152.004.227.014.394.042.752.251.982.574.304.443.406.993.282 1.515a2.91 2.91 0 01-.43.99c-.317.487-.67.95-1.056 1.384-.83.974-1.66 1.944-2.494 2.909a.155.155 0 00-.034.095V24h10.402v-2.226h-7.36c.017-.025.03-.041.042-.057.608-.769 1.217-1.537 1.827-2.305.359-.454.72-.908 1.032-1.395a3.791 3.791 0 00.539-2.864 3.695 3.695 0 00-1.083-1.979 3.704 3.704 0 00-2.616-1.082c-.905-.012-1.81 0-2.721 0l-.062-.015zm14.844 7.452v-7.457h-2.205v7.457h2.205zm-7.374 0h2.926v-4.341c-.974 1.45-1.944 2.892-2.92 4.34h-.006zm7.38 4.469V21.77h-2.211v2.227h2.21z"
                    fill="#A02E2B"
                />
                <path
                    d="M3.457 10.86h9.885V25.2H3.458v-.08l-.001-14.26zm3.441 8.288h5.225v-2.236H6.898v-2.609h5.228v-2.228H4.672v11.922h7.451v-2.234H6.898v-2.615z"
                    fill="#6D6E71"
                />
            </g>
        </g>
    </svg>
);

export default SvgLogoE24;
